import React from 'react'
import StarsIcon from '@material-ui/icons/Stars';
import Footer from './Footer'

function Grouprate() {
    return (
        <div className='grouprates_container'>
            <div className="deals_img">
                <img src="assets/conference room.webp" alt="hotel" />
            </div>
            <div className="overlay_home"></div>
            <div className="grouprates_subsections">
                <div className="grouprates_left">
                    <h5>Questions? Call us now (+1)747 249 8760</h5>
                    <div className="main_text">
                        Get group hotel rates for sports teams, weddings,
                         meetings or any group event!
                    </div>
                    <h4>it's completely FREE!</h4>
                </div>
                <div className="groupratesright">
                    <div className="grouprates_form">
                        <form action="">
                            <div className="input_full">
                                <input type="text" placeholder='Destination' />

                            </div>
                            <div className="input_half">
                                <input type="date" name="" id="" placeholder='Check-in' />
                                <input type="date" name="" id="" placeholder='Check-out'/>
                            </div>
                            <div className="add_content">
                                <span>+</span>
                                <p>Add another city or alternative dates</p>
                            </div>
                            <div className="input_full">
                                <label htmlFor="group_type">Group Type</label>
                                <div className="selections">
                                <select name="event" id="event">
                                    <option value="wedding"> </option>
                                    <option value="conference">Conference</option>
                                    <option value="meetings">Association</option>
                                    <option value="sport">Stag or Hen party</option>
                                    <option value="sport">Business Meeting</option> 
                                    <option value="sport">Bus Tour</option>
                                    <option value="sport">Charity Event</option>
                                    <option value="sport">Class Reunions</option>
                                    <option value="sport">Convention</option>
                                    <option value="sport">Societies and Alumni</option>
                                    <option value="sport">Millitary</option>
                                    <option value="sport">Music Bands</option>
                                </select>
                                </div>

                                </div>
                                <div className="input_half">
                                    <div className="input_withlabels">
                                        <label htmlFor="rooms"># ROOMS</label>
                                        <input type="text" />
                                    </div>
                                    <div className="input_withlabels">
                                        <label htmlFor="rooms">IDEAL STAR RATING</label>
                                        <div className="selections">
                                            <select name="rating" id="rating">
                                                <option value="1star"> </option>
                                                <option value="1-2star">1-2 star</option>
                                                <option value="1-3star">1-3 star</option>
                                                <option value="2-3star">2-3 star</option>
                                                <option value="2-4star">2-4 star</option>
                                                <option value="3-4star">3-4 star</option>
                                                <option value="3-5star">3-5 star</option>
                                                <option value="4-5star">4-5 star</option>
                                            </select>
                                          </div>
                                    </div>

                                </div>
                                <div className="input_withlabels">
                                    <label htmlFor="budget">IDEAL BUDGET PER NIGHT</label>
                                    <input type="range" name="price" id="" min='$39' max='$250+' />
                                </div>
                                <div className="button_submit">
                          <input type="button" value="Continue " />
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="groupates_bottomsection">
                <div className="bottom_contents">
                    <h2>
                    Get competitive quotes fast as hotels bid to get your group business.
                    </h2>
                    <div className="blue_tick">
                        <span>
                            <StarsIcon />
                        </span>
                        <h2>
                        Over one thousand groups booked
                        </h2>
                    </div>
                </div>
                <div className="bottom_gallery">
                    <img src="assets/sport teams.webp" alt="sport" />
                    <img src="assets/sport teams.webp" alt="sport" />
                    <img src="assets/sport teams.webp" alt="sport" />
                </div>

            </div>
            <div className="group_guarantee">
                <h4>
                Save up to 70%. Lowest group rate - guaranteed!*
                </h4>
            </div>
            <Footer />

        </div>
    )
}

export default Grouprate
